import { apiUrl } from "../constans";
import apiClient from '../libs/axios';

const API_BASE = `${apiUrl}/v2/localidades`;

// Respaldo por si /niveles falla: la jerarquia no cambia, asi la pantalla
// sigue permitiendo consultar aunque no sepamos los extras ni los portales.
export const NIVELES_DEFAULT = [
    { nivel: 'paises', padre: null, hijo: 'departamentos', extras: ['iso2', 'iso3', 'phonecode', 'state'] },
    { nivel: 'departamentos', padre: 'paises', hijo: 'ciudades', extras: ['iso2'] },
    { nivel: 'ciudades', padre: 'departamentos', hijo: 'zonas', extras: [] },
    { nivel: 'zonas', padre: 'ciudades', hijo: 'barrios', extras: ['descripcion'] },
    { nivel: 'barrios', padre: 'zonas', hijo: null, extras: ['descripcion'] },
];

const localidades = {
    namespaced: true,
    state: {
        niveles: NIVELES_DEFAULT,
        portales: [],
        // Solo super admin puede escribir; el backend igual responde 403 si no
        puedeEditar: false,
        loading: false,
        error: null,
    },

    mutations: {
        setConfig(state, data) {
            state.niveles = data?.niveles?.length ? data.niveles : NIVELES_DEFAULT;
            state.portales = data?.portales || [];
            state.puedeEditar = !!data?.puede_editar;
        },

        setLoading(state, loading) {
            state.loading = loading;
        },

        setError(state, error) {
            state.error = error;
        },

        clearError(state) {
            state.error = null;
        },
    },

    // Los listados y detalles no se guardan en el state: cada columna de la
    // pantalla lleva su propio listado y la vista decide cuando refrescar.
    actions: {
        async getNivelesAction({ commit }) {
            commit('clearError');
            try {
                const response = await apiClient.get(`${API_BASE}/niveles`);
                const data = response.data.data || {};
                commit('setConfig', data);
                return data;
            } catch (error) {
                commit('setError', error.response?.data?.data || 'Error al cargar la configuración de localidades');
                throw error;
            }
        },

        // params: { parent_id, q, estado, per_page, page } — todos opcionales
        async listarAction(_, { nivel, params = {} }) {
            const response = await apiClient.get(`${API_BASE}/${nivel}`, { params });
            return response.data.data || {};
        },

        async detalleAction(_, { nivel, id }) {
            const response = await apiClient.get(`${API_BASE}/${nivel}/${id}`);
            return response.data.data || {};
        },

        async usoAction(_, { nivel, id }) {
            const response = await apiClient.get(`${API_BASE}/${nivel}/${id}/uso`);
            return response.data.data || { total: 0, detalle: {} };
        },

        async crearAction({ commit }, { nivel, payload }) {
            commit('setLoading', true);
            try {
                const response = await apiClient.post(`${API_BASE}/${nivel}`, payload);
                return response.data.data || {};
            } finally {
                commit('setLoading', false);
            }
        },

        // payload solo con los campos que cambian; cambiar parent_id mueve la
        // localidad con todo lo que tiene debajo
        async actualizarAction({ commit }, { nivel, id, payload }) {
            commit('setLoading', true);
            try {
                const response = await apiClient.put(`${API_BASE}/${nivel}/${id}`, payload);
                return response.data.data || {};
            } finally {
                commit('setLoading', false);
            }
        },

        // Sin reasignarA borra solo si no esta en uso (si no, 409 EN_USO).
        // Con reasignarA fusiona: todo pasa al destino y luego se borra.
        async eliminarAction({ commit }, { nivel, id, reasignarA = null }) {
            commit('setLoading', true);
            try {
                const params = reasignarA ? { reasignar_a: reasignarA } : {};
                const response = await apiClient.delete(`${API_BASE}/${nivel}/${id}`, { params });
                return response.data.data || {};
            } finally {
                commit('setLoading', false);
            }
        },

        // Reemplaza la lista completa: lo que no se envia se borra
        async homologarAction({ commit }, { nivel, id, portales }) {
            commit('setLoading', true);
            try {
                const response = await apiClient.put(`${API_BASE}/${nivel}/${id}/portales`, { portales });
                return response.data.data || [];
            } finally {
                commit('setLoading', false);
            }
        },
    },
};

export default localidades;
